var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i-select',_vm._g({attrs:{"value":_vm.value,"clearable":true}},_vm.$listeners),_vm._l((_vm.senders),function(sender){return _c('i-option',{key:sender.id,attrs:{"value":sender.name,"label":sender.name}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }